import React from 'react';
import classNames from 'classnames';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';

function GA2SectorKPIsTableBody({ children, className, style }) {
  return (
    <PerfectScrollbar className={classNames('rt-tbody', className)} style={style}>
      {children}
    </PerfectScrollbar>
  );
}

export default GA2SectorKPIsTableBody;
